import { Helmet } from "react-helmet";
import customCSS from "./Allpayments.module.css";
import ReactGA from "react-ga4";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import InputComponent from "../../components/Form/InputComponent";
import { InputComponentAsSignupStyle } from "../../pages/Signup";
import Spinner from "../../components/Spinner/Spinner";
import { makeCustomDonation } from "../../utils/api";
import Swal from 'sweetalert2'

export default function UpdateDonations() {
    const location = useLocation();
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin Update-Donations Page' });
      }, []);

    return <div style={{position: 'relative'}} className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Update-Donations</title>
        </Helmet>
        <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>Update Donations</h1>
          <AddDonationsPage />
        </div>
    </div>
}

function AddDonationsPage() {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [customErrorMessage, setCustomErrorMessage] = useState("");
  const formik = useFormik({
    initialValues: { amount: '' },
    onSubmit: async (values, { resetForm }) => {
      await handleSubmit(values);
      resetForm();
    }
  });
  async function handleSubmit({amount}) {
    try {
      setIsButtonLoading(true);
      await makeCustomDonation(amount);
      Swal.fire({
        title: "Donation added successfully!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true
      })
    } catch (error) {
        Swal.fire({
          icon: "error",
          text: "Something went wrong!",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
      });
    }
    setIsButtonLoading(false);
  }
  return <div style={{
      height: '100%',
      width: '100%',
      padding: '5rem 10rem',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <form style={{width: "75%"}}>
        <InputComponentAsSignupStyle property="amount" placeholder="Amount In USD" inputType="text" formik={formik} />
        <div className="error-message" style={{color:'red'}}>{customErrorMessage}</div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div onClick={formik.handleSubmit} className='sign-in-submit-button' style={{height: '3rem', display: 'flex', justifyContent: 'center', padding: '0.5rem', alignItems: 'center', width: '50%'}}>
            {isButtonLoading ? <Spinner color="#2691d9"/> : "Add Donation"}
          </div>
        </div>
      </form>
    </div>
}